import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import System9Palaces from './components/System9Palaces/System9Palaces';
import ProblemSolution from './components/ProblemSolution/ProblemSolution';
import Features from './components/Features/Features';
import Tools from './components/Tools/Tools';
import Testimonial from './components/Testimonial/Testimonial';
import Pricing from './components/Pricing/Pricing';
import Process from './components/Process/Process';
import FAQ from './components/FAQ/FAQ';
import CTA from './components/CTA/CTA';
import Footer from './components/Footer/Footer';
import Snowfall from './components/Shared/Snowfall';
import ClickSpark from './components/Shared/ClickSpark';
import PaymentModal from './components/PaymentModal/PaymentModal';
import ThankYouPage from './components/ThankYouPage/ThankYouPage';
import Oferta from './components/Oferta/Oferta';
import './styles/globals.css';

function LandingPage({ onBuyClick }) {
  return (
    <>
      <ClickSpark sparkColor="#D4AF37" sparkCount={12} sparkSize={8}>
        <Snowfall />
        <Header onBuyClick={onBuyClick} />
        <Hero onBuyClick={onBuyClick} />
        <About />
        <System9Palaces />
        <ProblemSolution />
        <Features />
        <Tools />
        <Testimonial />
        <Pricing onBuyClick={onBuyClick} />
        <Process />
        <FAQ />
        <CTA onBuyClick={onBuyClick} />
        <Footer />
      </ClickSpark>
    </>
  );
}

function App() {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  const openPaymentModal = () => {
    setIsPaymentModalOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
  };

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/" 
          element={
            <>
              <LandingPage onBuyClick={openPaymentModal} />
              <PaymentModal isOpen={isPaymentModalOpen} onClose={closePaymentModal} />
            </>
          } 
        />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/oferta" element={<Oferta />} />
      </Routes>
    </div>
  );
}

export default App;

